module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Covid-19 Life")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-staying-at-home"
    }
  }, [_vm._v("Chapter 1: Staying at Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-working-for-the-nhs"
    }
  }, [_vm._v("Chapter 2: Working for the NHS")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-3-housing-covid-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Housing COVID-19")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-4-friendship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Friendship")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-5-general-porters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: General Porters")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-6-what-did-i-learn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: What Did I Learn")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-7-discussing-politics",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Discussing Politics")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-8-benefits",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Benefits")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-9-why-or-not-would-someone-want-to-leave-the-nhs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Why or Not Would Someone Want to Leave the NHS?")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-10-medical-records",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Medical Records")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-11-what-is-the-difference-between-porters-level-0-and-level-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: What Is the Difference Between Porter’s Level 0 and Level 2?")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-12-tests-and-vaccinations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Tests and Vaccinations")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-13-covid-19-patients",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: COVID-19 Patients")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-14-what-type-of-patients-do-we-deal-with",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: What Type of Patients Do We Deal With?")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-15-changes-day-by-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Changes Day by Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-16-mle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: MLE")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-17-am-i-happy-to-be-here",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Am I Happy to Be Here?")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#last-word",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Word")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0